import React from "react"

const userInfoContext = React.createContext({
	features: [],
	org: {},
	terms_accepted: false
})

export default userInfoContext
